export default {
  wrapperColor: '',
};
